import { contentType } from '../../../utils/ActionTypes';
import { createReducerWraper } from '../../../utils/Reducer';

export const transactionReducer = createReducerWraper(contentType.TRANSACTION);
